<script setup lang="ts">
import { DonutChart } from '@/components/ui/chart-donut'

interface Data {
    name: string
    total: number
}

defineProps<{
    title: string
    data: Data[]
    colors: string[]
    sublabel?: string
    valueFormatter?: (tick: number, i?: number, ticks?: number[]) => string
}>()
</script>

<template>
    <div class="p-4 lg:p-8">
        <h3 class="mb-8 text-lg font-bold">{{ title }}</h3>
        <DonutChart
            index="name"
            category="total"
            :data="data"
            :colors="colors"
            :sublabel="sublabel"
            :arc-width="32"
            :centralLabelOffsetY="sublabel ? 10 : 0"
            :value-formatter="valueFormatter"
        />
        <ul class="mt-8 flex flex-wrap items-center justify-center gap-3">
            <li v-for="(item, index) in data" :key="item.name" class="flex items-center gap-2 text-sm text-gray-500">
                <span :style="{ backgroundColor: colors[index] }" class="inline-block h-2 w-2 rounded-full"></span>{{ item.name }}
            </li>
        </ul>
        <div class="mx-auto mt-6 flex w-full flex-wrap items-center justify-center gap-2 lg:max-w-3xl">
            <slot name="total-cards" />
        </div>
    </div>
</template>
